import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const temperature_ABOVE: typeof valueTypeRenderers.temperature_ABOVE = {
  label: () => unitConverter.temperatureAboveCanopy().titleWithoutUnit(),
  point: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.temperatureAboveCanopy().title(),
      render: (n) => unitConverter.temperatureAboveCanopy(n).valueAsString(),
    }),
}
